module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/DEUT_contents"
    }
  }, [_vm._v("Select bibliography")])]), _vm._v(" "), _c('h3', {
    staticClass: "b_head",
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Cousins, Peter E., ‘Deuteronomy’ in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The International Bible Commentary")]), _vm._v(" (Marshall Pickering, 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Craigie, Peter C., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Deuteronomy")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New International Commentary on the Old Testament")]), _vm._v(", Eerdmans, 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Harrison, R. K., and Manley, G. T., ‘Deuteronomy’ in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Bible Commentary Revised")]), _vm._v(" (IVP, 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Kline, Meredith G., ‘Deuteronomy’ in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wycliffe Bible Commentary")]), _vm._v(" (Oliphants, 1963).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Mayes, A. D. H., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Century Bible")]), _vm._v(", Oliphants, 1979).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Payne, David F., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Daily Study Bible")]), _vm._v(" – Old Testament, St Andrew Press, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Phillips, Anthony, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cambridge Bible Commentary")]), _vm._v(", CUP, 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Robinson, H. Wheeler, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy and Joshua")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Century Bible")]), _vm._v(", 1907).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Thompson, J. A., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy: An Introduction and Commentary")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tyndale Old Testament Commentaries")]), _vm._v(", IVP, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("von Rad, Gerhard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Old Testament Library")]), _vm._v(", SCM, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Wright, G. E., ‘Deuteronomy’ in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Interpreter’s Bible")]), _vm._v(", ﻿Vol. 2 (Abingdon Press, 1953).")]), _vm._v(" "), _c('h3', {
    staticClass: "b_head",
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_vm._v("Other works")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Blanch, Stuart, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Ten Commandments")]), _vm._v(" (Hodder and Stoughton, 1981).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Clements, R. E., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy: Old Testament Guides")]), _vm._v(" (Sheffield Academic Press, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("__, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God’s Chosen People: A Theological Interpretation of the Book of Deuteronomy")]), _vm._v(" (SCM, 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Davidman, Joy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Smoke on the Mountain: An Interpretation of the Ten Commandments in Terms of Today")]), _vm._v(" (Hodder and Stoughton, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Eddison, John, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God’s Frontiers")]), _vm._v(" (Scripture Union, 1972).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Field, David, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God’s Good Life: The Ten Commandments at the End of the Twentieth Century")]), _vm._v(" (IVP, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Kidner, Derek, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hard Sayings: The Challenge of Old Testament Morals")]), _vm._v(" (Tyndale Press, 1972).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Kline, Meredith G., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Structure of Biblical Authority")]), _vm._v(" (Eerdmans, 1972).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("McConville, J. G., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Law and Theology in Deuteronomy")]), _vm._v(" (Journal for the Study of the Old Testament Supplement Series 33, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Nicholson, E. W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy and Tradition")]), _vm._v(" (Blackwell, 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Phillips, Anthony, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancient Israel’s Criminal Law: A New Approach to the Decalogue")]), _vm._v(" (Darton, Longman and Todd, 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Shields, Norman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pattern for Life")]), _vm._v(" (Evangelical Press, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Weinfeld, M., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deuteronomy and the Deuteronomic School")]), _vm._v(" (Clarendon Press, 1972).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Wenham, John W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Enigma of Evil: Can We Believe in the Goodness of God?")]), _vm._v(" (IVP, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Wright, Christopher J. H., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God’s People in God’s Land: Family, Land and Property in the Old Testament")]), _vm._v(" (Paternoster/Eerdmans, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("__, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Living as the People of God: The Relevance of Old Testament Ethics")]), _vm._v(" (IVP, 1983).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a7f6b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/DEUT_bibliog.vue
// module id = 72
// module chunks = 0